module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer bgfff"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "help left"
  }, [_c('dl', [_c('dt', [_vm._v("新手帮助")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("网站介绍")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("帮助中心")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("我是买家")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("会员注册")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("会员介绍")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("购买流程")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("我是卖家")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("会员注册")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("如何发布资源")])]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "../about/help.html"
    }
  }, [_vm._v("会员介绍")])])])]), _vm._v(" "), _c('div', {
    staticClass: "code left"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../assets/images/code1.jpg")
    }
  }), _c('br'), _vm._v("有木头公众号")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/logo/xiao_shop.jpg")
    }
  }), _c('br'), _vm._v("有木头小程序")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/logo/xiao_vip.jpg")
    }
  }), _c('br'), _vm._v("商家版小程序")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/logo/xiao_erp.jpg")
    }
  }), _c('br'), _vm._v("仓储系统小程序")])]), _vm._v(" "), _c('div', {
    staticClass: "service left"
  }, [_c('div', {
    staticClass: "tel"
  }), _vm._v(" "), _c('strong', [_vm._v("400-723-0868")]), _vm._v(" "), _c('p', [_vm._v("客服热线（时间：9:00-18:00）")]), _vm._v(" "), _c('img', {
    attrs: {
      "border": "0",
      "onclick": "window.open('http://wpa.qq.com/msgrd?v=3&uin=2885431052&site=qq&menu=yes')",
      "src": "https://pub.idqqimg.com/qconn/wpa/button/button_11.gif",
      "alt": "点击这里给我发消息",
      "title": "点击这里给我发消息"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "border": "0",
      "onclick": "window.open('http://wpa.qq.com/msgrd?v=3&uin=2885431052&site=qq&menu=yes')",
      "src": "https://pub.idqqimg.com/qconn/wpa/button/button_11.gif",
      "alt": "点击这里给我发消息",
      "title": "点击这里给我发消息"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v("\n        有木头youmutou.com　版权所有　copyright ©2016　粤ICP备15108043号-1　　　　地址：广东省东莞市大岭山镇太公岭村渭东路78号\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-69458415"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 471
// module chunks = 31